const toggleMenu = document.querySelector(".hamburger");
const pageBody = document.body; // <body>, not ".page-body" (if you have a wrapper, adjust)
const menu = document.querySelector(".main-menu");
const menuItems = document.querySelectorAll("li.has-submenu");

// Utility to toggle ARIA expanded
function setAriaExpanded(el, expanded) {
	if (el) {
		el.setAttribute("aria-expanded", expanded ? "true" : "false");
	}
}

// Utility to trap focus inside element
function trapFocus(element) {
	const focusableEls = element.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
	const firstFocusableEl = focusableEls[0];
	const lastFocusableEl = focusableEls[focusableEls.length - 1];

	function handleFocus(e) {
		if (e.key !== "Tab") return;

		if (e.shiftKey) { // backward
			if (document.activeElement === firstFocusableEl) {
				e.preventDefault();
				lastFocusableEl.focus();
			}
		} else { // forward
			if (document.activeElement === lastFocusableEl) {
				e.preventDefault();
				firstFocusableEl.focus();
			}
		}
	}

	element.addEventListener("keydown", handleFocus);

	// Remove on close
	return () => element.removeEventListener("keydown", handleFocus);
}

function closeMobileMenu() {
	setAriaExpanded(toggleMenu, false);
	pageBody.classList.remove("navigation-active-mobile", "lock-scroll");
	toggleMenu.classList.remove("is-active");
	if (menu._removeTrap) menu._removeTrap();
}

function closestLink(node) {
	while (node && node !== menu) {
		if (node.tagName === "A") return node;
		node = node.parentElement;
	}
	return null;
}

function scrollToAnchorWithHeaderOffset(hash) {
	// Scroll to anchor target accounting for sticky header height
	if (!hash) return;
	const target = document.getElementById(hash);
	const header = document.querySelector('.iach-site-header');
	if (target && header) {
		const headerHeight = header.offsetHeight || 0;
		const rect = target.getBoundingClientRect();
		const targetScrollY = rect.top + window.pageYOffset - headerHeight;
		window.scrollTo({
			top: targetScrollY,
			behavior: 'smooth'
		});
	}
}

function initToggleMenu() {
	// Hamburger menu
	if (toggleMenu && menu) {
		toggleMenu.addEventListener("click", function() {
			const isActive = toggleMenu.classList.toggle("is-active");
			setAriaExpanded(toggleMenu, isActive);

			// Only toggle these (CSS will handle everything else with media queries)
			pageBody.classList.toggle("navigation-active-mobile", isActive);
			pageBody.classList.toggle("lock-scroll", isActive);

			if (isActive) {
				const firstLink = menu.querySelector("a");
				if (firstLink) firstLink.focus();
				menu._removeTrap = trapFocus(menu);
			} else {
				if (menu._removeTrap) menu._removeTrap();
			}
		});

		document.addEventListener("keydown", (e) => {
			// Escape closes mobile nav (only if nav panel is open)
			if (e.key === "Escape" && pageBody.classList.contains("navigation-active-mobile")) {
				closeMobileMenu();
				toggleMenu.focus();
			}
		});

		// Close menu for relative and absolute anchor links to current page
		menu.addEventListener("click", function(e) {
			const link = closestLink(e.target);
			if (!link) return;

			const href = link.getAttribute("href");
			const currentUrlNoHash = window.location.origin + window.location.pathname;

			if (
				href &&
				(
					href.startsWith("#") || // #section
					href.startsWith(currentUrlNoHash + "#") // https://site/page#section
				)
			) {
				closeMobileMenu();

				// Scroll with header offset shortly after menu closes
				setTimeout(function() {
					let hash;
					if (href.startsWith('#')) {
						hash = href.substring(1);
					} else if (href.includes('#')) {
						hash = href.split('#')[1];
					}
					scrollToAnchorWithHeaderOffset(hash);
				}, 300); // adjust delay as needed for your menu closing animation
			}
		});
	}

	// Dropdown submenus
	menuItems.forEach((el, i) => {
		const activatingA = el.querySelector("a");
		const submenu = el.querySelector("ul");
		if (!activatingA || !submenu) return;

		if (!submenu.id) submenu.id = `submenu-${i+1}`;

		let btn = el.querySelector(".submenu-button-icon");
		if (!btn) {
			btn = document.createElement("button");
			btn.className = "submenu-button-icon";
			btn.setAttribute("aria-label", `Show submenu for “${activatingA.textContent.trim()}”`);
			btn.setAttribute("aria-controls", submenu.id);
			btn.setAttribute("aria-expanded", "false");
			btn.type = "button";
			btn.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden">Show submenu for “' + activatingA.textContent.trim() + '”</span>';
			activatingA.insertAdjacentElement("afterend", btn);
		}

		btn.addEventListener("click", function(event) {
			const isOpen = el.classList.contains("open");
			el.classList.toggle("open", !isOpen);
			setAriaExpanded(btn, !isOpen);
			setAriaExpanded(activatingA, !isOpen);
			if (!isOpen) {
				submenu.removeAttribute("hidden");
			} else {
				submenu.setAttribute("hidden", "");
			}
			event.preventDefault();
		});

		activatingA.addEventListener("keydown", function(e) {
			if ((e.key === "Enter" || e.key === " ") && submenu) {
				e.preventDefault();
				btn.click();
			}
		});
	});

	// Remove [hidden] from all submenus on desktop -- required for CSS :hover to work
	function fixSubmenuHiddenForDesktop() {
		const isDesktop = window.innerWidth > 1024;
		document.querySelectorAll('.menu-item.has-submenu > .submenu').forEach(function(submenu){
			if (isDesktop) {
				submenu.removeAttribute('hidden');
			} else if (!submenu.closest('.open')) {
				submenu.setAttribute('hidden', '');
			}
		});
	}
	fixSubmenuHiddenForDesktop();
	window.addEventListener('resize', fixSubmenuHiddenForDesktop);

	// Desktop resize restores nav state (mobile panel should never be open on desktop)
	window.addEventListener('resize', function() {
		if (window.innerWidth > 1024) {
			closeMobileMenu();
		}
	});
}

// Run anchor scroll patch on initial page load
document.addEventListener('DOMContentLoaded', function() {
	if (window.location.hash) {
		setTimeout(function() {
			// Remove leading '#' and scroll with offset
			scrollToAnchorWithHeaderOffset(window.location.hash.substring(1));
		}, 100); // delay lets browser scroll first, then correct the position
	}
});

document.addEventListener('DOMContentLoaded', () => {
	initToggleMenu();
});